import { createContext, useMemo, useState } from "react";
import type { PropsWithChildren } from "react";
import { useSafeContext } from "@aviv-unified-frontend/internal";
import type { ApplicationRegistryItem } from "@aviv-unified-frontend/registry";

import { useGlobalStore } from "../../utils/useGlobalStore/useGlobalStore";

import { APPLICATIONS_CACHED } from "./createApplicationCache";

type RuntimeApplicationContextOutput = {
  id: ApplicationRegistryItem["id"] | undefined;
  setId: (id: ApplicationRegistryItem["id"]) => void;
  version: string | undefined;
};

const RuntimeApplicationContext =
  createContext<RuntimeApplicationContextOutput | null>(null);

export const RuntimeApplicationProvider = ({ children }: PropsWithChildren) => {
  const { initialApplication } = useGlobalStore();
  const [id, setId] = useState(initialApplication?.id);

  const value = useMemo(() => {
    const version = id && APPLICATIONS_CACHED.getApplication(id)?.version;

    return {
      id,
      setId,
      version,
    };
  }, [id]);

  return (
    <RuntimeApplicationContext.Provider value={value}>
      {children}
    </RuntimeApplicationContext.Provider>
  );
};

export const useRuntimeApplication = () =>
  useSafeContext(
    {
      package: "@aviv-unified-frontend/branded-shell",
      module: "runtimeApplication",
    },
    RuntimeApplicationContext,
  );
